import { OverlayContainerView } from "@gaming/srvg-classes-core";

declare const $:any;

export class OverlayView extends OverlayContainerView {
    $sporteventTitles: any;
    $overlayHeader: any;
    $scoreBoard: any;
    timings: any;

    constructor (options){
        options = options || {};
        super( options );
        this.name = 'overlayView';

        this.layerClasses = {
            pre_match_1: 'overlay_only_with_teams',
            pre_match_2: 'overlay_only_with_teams',
            pre_match_extendedBetting: 'overlay_only_with_teams',
            post_match: 'overlay_with_scores'/*,
             post_season: ''*/
        };

        this.$sporteventTitles =  this.$domNode.find('.sportevent_title');
        var overlayHeaderSelector = options.headerElement || '#overlay_header';
        this.$overlayHeader = $(overlayHeaderSelector);
        this.$scoreBoard = $(overlayHeaderSelector).find('.scoreboard');
        this.timings = [];
    }

    /**
     * set the title in the overlay with matchday and season
     * @param sporteventGroupTitle - season title
     * @param sporteventElementTitle - matchday title
     */
    setTitle(sporteventGroupTitle, sporteventElementTitle){
        this.$sporteventTitles.find('.sportevent_group_title').html(sporteventGroupTitle);
        this.$sporteventTitles.find('.sportevent_element_title').html(sporteventElementTitle);
    }


    /**
     * set the team information in the overlay headers
     * @param teamInformation contains [string] awayTeam/homeTeam with teamnames
     *        and [string] homeJerseyColor/awayJerseyColor with the hex code of the team colors (without the #-sign)
     */
    setTeamInformation(teamInformation){
        var that = this,
            sides = {player1: 'away', player2: 'home'};

        // switch the position of away and home
        if (srvg.featuresInstances.getSwitchHomeAwayAllocation()){
            sides = {player1: 'home', player2: 'away'};
        }

        // fallback transparent background and formatting of the color with #-sign
        var color = {home: 'transparent', away: 'transparent'};
        if (teamInformation.awayJerseyColor){
            color.away = '#' + teamInformation.awayJerseyColor;
        }
        if (teamInformation.homeJerseyColor){
            color.home = '#' + teamInformation.homeJerseyColor;
        }

        // insert the team names and team colors into the overlays
        $.each(sides, function(player, side) {
            that.$overlayHeader.find('.'+player+' .teamname').html(teamInformation[side+'Team']);
            that.$overlayHeader.find('.'+player+' .teamcolor').css('background-color', color[side]);
        });
    }

    /**
     * reset all team information, like names and colors, in the overlays
     */
    resetTeamInformation(){
        this.setTeamInformation({
            awayTeam: '',
            homeTeam: '',
            awayJerseyColor: null,
            homeJerseyColor: null
        });
    }

    /**
     * set the results in the scoreboard in the overlays
     * @param result - results of the match
     */
    setTeamResults(result){
        var elements = {player1: 'away_score', player2: 'home_score'},
            that = this;

        if (srvg.featuresInstances.getSwitchHomeAwayAllocation()){
            elements = {player1: 'home_score', player2: 'away_score'};
        }

        $.each(elements, function(playerClass, sideIndicator){
            var tmpElement = that.$scoreBoard.find('.'+playerClass);
            tmpElement.find('.quarter1').html(result['first_quarter_over'][sideIndicator]);
            tmpElement.find('.quarter2').html(result['second_quarter_over'][sideIndicator]);
            tmpElement.find('.quarter3').html(result['third_quarter_over'][sideIndicator]);
            tmpElement.find('.quarter4').html(result['fourth_quarter_over'][sideIndicator]);
            tmpElement.find('.overtime').html(result['fifth_quarter_over'][sideIndicator]);
            tmpElement.find('.result').html(result['match_over'][sideIndicator]);
        });
        if(result.overtime){ this.$scoreBoard.addClass('with_overtime');}
        else{this.$scoreBoard.removeClass('with_overtime');}
    }

    /**
     * reset all results in the scoreboard in the overlays
     */
    resetTeamResults(){
        var sides = ['away_score', 'home_score'],
            events = [
                'first_quarter_over',
                'second_quarter_over',
                'third_quarter_over',
                'fourth_quarter_over',
                'fifth_quarter_over',
                'match_over'
            ],
            results = {};


        $.each(events, function(i, event){
            results[event] = {};
            $.each(sides, function(j, side){
                results[event][side] = '';
            });
        });
        results['overtime'] = false;
        this.setTeamResults(results);
    }

    /**
     * show the overlays. controls the whole animation and the process of these.
     * @param [string|array] elements of overlays, e.g. 'pre_match1'
     * @param [number] periodDuration - how long could we show the overlay (from the current time)?
     * @param [number] maximumPhaseLength - how long is the phase in total?
     * @param [function callback] - options
     * @param [object channelSwitch] -  options for channel switching or switching the channels in the overlays
     *                                  for extended betting
     *                                  e.g.: {switchMethod: function() {}, videoChannel: 0}
     *
     * @todo maximumPhaseLength is not used at the moment,
     */
    showOverlay(elements:any, periodDuration:number, maximumPhaseLength?:number, callback?:any, channelSwitch?:any){
        var that = this;
        periodDuration = periodDuration*1000;
        this.resetOverlays(elements);
        var meantime = 0;
        var wrapperClass = '';
        callback = callback || function() {};


        if (typeof elements === "object"){
            meantime = this.calculateMeantimePerOverlay(periodDuration, elements.length);
            //var maxDurationPerOverlay = this.calculateMeantimePerOverlay(maximumPhaseLength, elements.length);
            wrapperClass = elements[0];
        }else{
            meantime = this.calculateMeantimePerOverlay(periodDuration);
            wrapperClass = elements;
        }

        // if we have not enough time for the minimum display time...
        if (meantime < this.minimumDisplayTime){
            // try it only with the first overlay and not with all
            if (typeof elements === "object" && elements.length > 1){
                this.showOverlay(elements[0], periodDuration, maximumPhaseLength, callback);
                return;
            }else{
                // if there is no space for one overlay, show nothing.
                return;
            }
        }

        // wait buffer time
        setTimeout(function() {
            that.setWrapperClass(wrapperClass);
            // show Header
            $.when(
                that.showContainer()
            ).done(function(){
                // show each single overlay

                var animateSingleOverlay = function(index, overlayElement, containerView, overlayDuration) {
                    var timePerOverlay = ((containerView.speed * 2) + overlayDuration);
                    // show
                    setTimeout(function() {
                        containerView.showLayer(overlayElement);

                        if (elements === "pre_match_extendedBetting"){  // pre match extended betting
                            if (channelSwitch && channelSwitch.switchMethod){
                                // start with default channel 0 if no channel was given
                                if(!channelSwitch['videoChannel']) {
                                    channelSwitch['videoChannel'] = 0;
                                }

                                var numberOfTeams = 8; // FIXME if necessary, if you have another cup modus
                                var timePerTeam = overlayDuration/numberOfTeams;
                                var minimumTeamTime = 7000;
                                if(timePerTeam < minimumTeamTime){
                                    timePerTeam = minimumTeamTime;
                                }

                                var showChannels = [];
                                showChannels.push(channelSwitch['videoChannel']);
                                for(var i=0; i<numberOfTeams; i++){
                                    if(i !== channelSwitch['videoChannel']){
                                        showChannels.push(i);
                                    }
                                }

                                var i = 0;
                                var that = this;

                                for(var showChannel in showChannels){
                                    (function(channel, i) {
                                        that.timings = setTimeout(function() {
                                            channelSwitch['switchMethod'](channel);
                                        }, i*timePerTeam);
                                    }(showChannels[showChannel], i));
                                    i++;
                                }

                                // setTtimeout reset overlay after hideLayer wih current channel
                                setTimeout(function() {
                                    channelSwitch['switchMethod'](showChannels[0]);
                                    // remove old timings
                                    var timingsLength = that.timings.length;
                                    if(timingsLength > 0){
                                        for(var j=0; j < that.timings; j++){
                                            clearTimeout(that.timings[j]);
                                        }
                                        that.timings = [];
                                    }
                                    // just a little bit buffer time for fading out
                                }, (containerView.speed*2 + overlayDuration + 1000));

                            }

                        }

                        //wait
                        setTimeout(function() {
                            // hide
                            containerView.hideLayer(overlayElement);
                        }, containerView.speed + overlayDuration);
                    }, index * timePerOverlay);
                };

                if (typeof elements === "object"){
                    $.each(elements, function(index, element){
                        animateSingleOverlay(index, element, that, meantime);
                    });
                }else{
                    var index = 0;
                    animateSingleOverlay(index, elements, that, meantime);
                }




            });


            // hide header / overlay
            setTimeout(function() {
                $.when(
                    that.hideContainer()
                ).done(function() {
                    callback();
                });
            }, periodDuration - (that.buffer + that.speed));
        }, this.buffer);
    }
}